import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { SectionHead, Reveal } from "../components/Motion";
import { label } from "../data/taxonomy";

export default function FAQ() {
  const [faqs, setFaqs] = useState([]);
  const [cat, setCat] = useState("all");
  const [policies, setPolicies] = useState("");

  useEffect(() => {
    api.get("/faqs").then((r) => setFaqs(r.data.faqs)).catch(() => {});
    api.get("/settings").then((r) => setPolicies(r.data.policies_text || "")).catch(() => {});
  }, []);

  const cats = ["all", ...new Set(faqs.map((f) => f.category))];
  const shown = cat === "all" ? faqs : faqs.filter((f) => f.category === cat);

  return (
    <div className="pt-28 pb-24 max-w-3xl mx-auto px-4 sm:px-6 min-h-screen" data-testid="faq-page">
      <SectionHead overline="Help Centre" title="Frequently Asked Questions" center
        sub="Orders, delivery, payments, gifting — everything in one place. Still stuck? founder@savyron.in" testid="faq-page-head" />
      <div className="flex flex-wrap justify-center gap-2 mb-10">
        {cats.map((c) => (
          <button key={c} onClick={() => setCat(c)}
            className={`text-[11px] tracking-[0.15em] uppercase rounded-full px-4 py-2 border transition-colors ${cat === c ? "bg-[#7E1E3F] text-[#FFFFFF] border-[#7E1E3F] font-semibold" : "border-[#7E1E3F]/25 text-[#857078] hover:border-[#7E1E3F]/60"}`}
            data-testid={`faq-cat-${c}`}>
            {c === "all" ? "All" : label(c)}
          </button>
        ))}
      </div>
      <div className="space-y-3">
        {shown.map((f) => (
          <Reveal key={f.id}>
            <details className="card-surface rounded-xl px-5 py-4 group" data-testid={`faq-item-${f.id}`}>
              <summary className="cursor-pointer list-none flex justify-between items-center text-[#45303A] text-sm sm:text-base font-medium">
                {f.question}
                <span className="text-[#7E1E3F] ml-4 transition-transform duration-300 group-open:rotate-45">+</span>
              </summary>
              <p className="mt-3 text-sm text-[#857078] leading-relaxed">{f.answer}</p>
            </details>
          </Reveal>
        ))}
      </div>
      {policies && (
        <div className="mt-12 card-surface rounded-2xl p-7" data-testid="policies-block">
          <h3 className="font-serif-lux text-2xl text-[#2E1A22] mb-4">Our Policies</h3>
          <p className="text-sm text-[#857078] leading-relaxed whitespace-pre-line">{policies}</p>
        </div>
      )}
    </div>
  );
}
